import { Fragment, MutableRefObject } from "react";
import { Button } from "react-bootstrap";
import { MessageView } from "@/interfaces/Chat";
import { ChatHistoryGap } from "@/hooks/useChatSync";
import MessageRow from "./MessageRow";
export default function MessageList({
  messages,
  gaps,
  onGap,
  historyRef,
  onScroll,
  onOlder,
  hasOlder,
  hasAfter,
  onAfter,
  loading,
  onJump,
  onReply,
  canWrite = false,
}: {
  messages: MessageView[];
  gaps: ChatHistoryGap[];
  onGap: (after: string) => unknown;
  historyRef: MutableRefObject<HTMLDivElement | null>;
  onScroll: () => void;
  onOlder: () => unknown;
  hasOlder: boolean;
  hasAfter: boolean;
  onAfter: () => unknown;
  loading: boolean;
  onJump: (id: string) => void;
  onReply?: (message: MessageView) => void;
  canWrite?: boolean;
}) {
  return (
    <div
      className="chat-history"
      ref={historyRef}
      onScroll={onScroll}
      role="region"
      aria-label="Historique des messages"
      tabIndex={0}
      aria-busy={loading}
    >
      {hasOlder && (
        <Button
          variant="link"
          className="chat-older"
          onClick={onOlder}
          disabled={loading}
        >
          Messages précédents
        </Button>
      )}
      {loading && (
        <p className="chat-empty" role="status">
          Chargement des messages…
        </p>
      )}
      {!loading && !messages.length && (
        <p className="chat-empty">Commencez la conversation.</p>
      )}
      {messages.map((message) => {
        const gap = gaps.find((item) => item.beforeMessageId === message.id);
        return (
          <Fragment key={message.id}>
            {gap && (
              <div className="chat-history-gap">
                <Button
                  variant="outline-primary"
                  disabled={loading}
                  onClick={() => onGap(gap.after)}
                >
                  Charger les messages intermédiaires
                </Button>
              </div>
            )}
            <MessageRow
              message={message}
              onJump={onJump}
              onReply={onReply}
              canWrite={canWrite}
            />
          </Fragment>
        );
      })}
      {hasAfter && (
        <Button variant="link" onClick={onAfter} disabled={loading}>
          Messages suivants
        </Button>
      )}
    </div>
  );
}
